import React from 'react'

const ChatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    {...props}
  >
    <path
      d='M3.57788 32.9524V6.70243C3.57788 5.90035 3.86347 5.21372 4.43465 4.64254C5.00583 4.07136 5.69246 3.78577 6.49455 3.78577H29.8279C30.63 3.78577 31.3166 4.07136 31.8878 4.64254C32.459 5.21372 32.7446 5.90035 32.7446 6.70243V24.2024C32.7446 25.0045 32.459 25.6912 31.8878 26.2623C31.3166 26.8335 30.63 27.1191 29.8279 27.1191H9.41121L3.57788 32.9524ZM9.41121 21.2858H21.0779V18.3691H9.41121V21.2858ZM9.41121 16.9108H26.9112V13.9941H9.41121V16.9108ZM9.41121 12.5358H26.9112V9.6191H9.41121V12.5358Z'
      fill='currentcolor'
    />
  </svg>
)

export default ChatIcon
